import { createSelector } from 'reselect'

export const getIncomingMailsDomain = (state, props) => {
  return state.kanbo.config.incomingMailDomain
}

export default createSelector(
  [getIncomingMailsDomain],
  (incomingMailsDomain) => ({
    incomingMailsDomain
  })
)
